package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.Typography

@Composable
fun ControllerPromptSelectionScreen(
    options: List<String>,
    onPromptSelected: (Int) -> Unit,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.Top),
        modifier = Modifier
            .fillMaxSize()
            .padding(8.dp)
    ) {
        Text(
            "Wähle eine Aufgabe aus",
            fontSize = Typography.Controller.title,
        )
        options.forEachIndexed { index, option ->
            Button(
                modifier = Modifier
                    .fillMaxWidth(),
                onClick = { onPromptSelected(index) },
            ) {
                Text(
                    option,
                    fontSize = Typography.Controller.body,
                )
            }
        }
    }
}